import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTrans } from "system/translations/hooks";
import Card from "components/atoms/Card";
import FormBuilder from "services/formBuilder/FormBuilder";
import {
  useGetRejectionReason,
  useUpdateRejectionReasons,
} from "modules/rejectionReasons/apiHooks";
import { useDeleteRejectionReasonHelper } from "modules/rejectionReasons/hooks";
import { createEditValidation } from "modules/rejectionReasons/validation";
import Loader from "components/atoms/Loader";
import { useCreateEditConfig } from "modules/rejectionReasons/constantHooks";
import SectionTitle from "components/atoms/SectionTitle";
import { DeleteIcon } from "evergreen-ui";
import Btn from "components/atoms/Btn";

const Update: React.FC = () => {
  const isEdit = true;
  const { _t } = useTrans();
  const history = useHistory();
  const routeParams: any = useParams();
  const { onDeleteWithConfirm } = useDeleteRejectionReasonHelper(_t);
  const { data: rejectionReasonsData = {}, isLoading } = useGetRejectionReason(
    routeParams.id
  );
  const { mutateAsync: onUpdate } = useUpdateRejectionReasons();
  const formConfig = useCreateEditConfig({
    isEdit: true,
  });
  const onSubmit = async (data: any) => {
    const { key, ...rest } = data;
    await onUpdate({ data: rest, id: key });
    history.goBack();
  };

  if (isLoading) {
    return <Loader formOverlay />;
  }

  return (
    <>
      <SectionTitle
        title={_t("edit_rejection_reason")}
        extra={
          <Btn
            kind={"default"}
            iconBefore={DeleteIcon}
            onClick={() => onDeleteWithConfirm({
              id: routeParams.id,
              allData: rejectionReasonsData 
            })}
          >
            {_t("delete_rejection_reason")}
          </Btn>
        }
      />
      <Card title={_t("edit_translation")}>
        <FormBuilder
          formItemsConfig={formConfig}
          showSubmit={false}
          formProps={{
            onSubmit: onSubmit,
            initialValues: { ...rejectionReasonsData },
            validationSchema: createEditValidation(_t, {
              isEdit,
            }),
          }}
        />
      </Card>
    </>
  );
};

export default Update;
